export const environment = {
  production: false,
  graphqlEndpoint: 'https://xoas5metezgwncyobzwsco7wxi.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  amplifyConfiguration: {
    userPoolId: 'eu-central-1_NTg3IFJeY',
    userPoolClientId: '4svlbi2mggu5ojstmun9247cnr',
    oauth: {
      domain: 'insolution-workshop-auth-domain-dev.auth.eu-central-1.amazoncognito.com',
      scopes: ['email', 'openid', 'profile'],
      redirectSignIn: ['https://d20sb767jddwzi.cloudfront.net/'],
      redirectSignOut: ['https://d20sb767jddwzi.cloudfront.net/'],
      responseType: 'code',
    },
  },
  rumConfiguration: {
    appMonitorId: 'b65160db-288c-4902-9ea4-5fb40fafdebc',
    identityPoolId: 'eu-central-1:4a5a134f-47a8-4b1d-bacc-22a0da07286e',
    region: 'eu-central-1',
    appVersion: 'web',
    sampleRate: 1,
  },
};
